import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FaRegMoon } from "react-icons/fa";
import { MdOutlineDashboard } from "react-icons/md";
import { FaRegBell } from "react-icons/fa";
import indianFlag from "../assets/india.png";
import userLogo from "../assets/user.png";
import { IoMailSharp } from "react-icons/io5";
import { RiAlertFill } from "react-icons/ri";
import { IoListOutline } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import { Navigate, useNavigate } from "react-router-dom";
import useAuth from "../useAuth";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to Log Out?");
    if (!confirmed) return;
    logout();
  };

  return (
    <div className="flex items-center sticky top-0 z-40 justify-between gap-4 bg-[#f5f7fa] py-3 px-6 border-b border-transparent">

      {/* Left Space (Leaves room for where logo is in sidebar) */}
      <div className="flex-none w-10"></div>

      {/* Center - Search Bar */}
      <div className="flex-1 max-w-2xl flex justify-center">
        <div className="relative w-full max-w-[600px] flex items-center">
          <FaSearch className="absolute left-4 text-slate-400" size={14} />
          <input
            type="text"
            placeholder="Let's find some stuff"
            className="w-full bg-white border border-slate-200 rounded-full py-2 pl-10 pr-24 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-slate-700 shadow-sm"
          />
          <div className="absolute right-4 flex items-center gap-1 cursor-pointer text-slate-500 hover:text-slate-700">
            <span className="text-[13px] font-medium">All files</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
      </div>

      {/* Right - Action Icons & User Avatar */}
      <div className="flex items-center gap-2 text-slate-500">
        <button className="p-2 rounded-full hover:bg-blue-300 hover:text-blue-900 bg-white text-blue-600  transition-colors tooltip" aria-label="Notifications">
          <FaRegBell size={18} />
        </button>
        <button className="p-2 rounded-full hover:bg-blue-300 hover:text-blue-900 bg-white text-blue-600  transition-colors tooltip" aria-label="Settings">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </button>
        <button className="p-2 rounded-full hover:bg-blue-300 hover:text-blue-900 bg-white text-blue-600  transition-colors tooltip" aria-label="Help">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </button>

        {/* Profile Avatar with Logout Dropdown */}
        <div className="relative group ml-1">
          <img
            className="w-8 h-8 rounded-full object-cover cursor-pointer hover:ring-2 hover:ring-slate-300 transition-all border border-slate-200"
            src={userLogo}
            alt="User profile"
            onClick={() => navigate("./profile")}
          />


          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-slate-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-1 z-50">
            <div className="px-4 py-2 border-b border-slate-100">
              <p className="text-sm font-bold text-slate-800 truncate">{user?.fullName}</p>
              <p className="text-xs text-slate-500 truncate">{user?.email || "user@example.com"}</p>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 rounded-full hover:bg-blue-300 hover:text-blue-900 bg-white text-blue-600  transition-colors flex justify-center items-center gap-2"
            >
              <LuLogOut size={16} />
              Sign out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
